import Torchie from "./Torchie";

export default Torchie;
